var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pay"},[_c('el-col',{attrs:{"xs":24,"sm":16,"md":16,"lg":16,"xl":16}},[_c('div',{staticClass:"left"})]),_c('el-col',{attrs:{"xs":24,"sm":8,"md":8,"lg":8,"xl":8}},[_c('div',{staticClass:"right"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }